/**
 * UILocation is used in telemetry to identify where users find and launch commands
 * Ex. How do users find and execute the Page Numbers command?
 * Ex. What commands do users use most from TellMe
 *
 * AppChromeUtils.ts maps the below UILocation enum with UILocation enum in msoserviceplatform
 */
export enum UILocation {
  ContextMenu = "ContextMenu",
  Floatie = "Floatie",
  Ribbon = "Ribbon",
  SingleLineRibbon = "SingleLineRibbon",
  MultilineRibbon = "MultilineRibbon",
  Overflow = "Overflow",
  TellMe = "TellMe",
  FarPeripheralControls = "FarPeripheralControls",
  NearPeripheralControls = "NearPeripheralControls",
  PeripheralOverflow = "PeripheralOverflow",
  Header = "Header",
  FileMenu = "FileMenu",
  StatusBar = "StatusBar",
  ActionHub = "ActionHub",
  ViewerToolbar = "ViewerToolbar",
  EditorToolbar = "EditorToolbar",
  SingleLineToolBar = "SingleLineToolBar",
  ToolBarOverflow = "ToolBarOverflow",
  TaskPane = "TaskPane",
  Canvas = "Canvas",
  KeepItToolbar = "KeepItToolbar",
  CopilotDAB = "CopilotDAB",
  CopilotQuickDAB = "CopilotQuickDAB",
  CopilotEditPreview = "CopilotEditPreview",
}

/**
 * UILocationExtended is used in telemetry to give more context to how a command was executed
 * If a command exists in multiple places, this enum can help identify which location is used to execute it
 * Ex. StatefulSplitButton used to replay a previous color setting or color clearing
 * Ex. Formatting was applied from a gallery vs an alternative ribbon tab where the same command is also surfaced
 */
export enum UILocationExtended {
  StatefulSplitButton = "StatefulSplitButton",
}

/**
 * Contextual UI has multiple surfaces which can host a control (floatie, context menu, search menu). This enum
 * allows us to distinguish these specific surfaces.
 */
export enum ContextualUILocation {
  Floatie = "Floatie",
  /** Contextual menu shows a search result */
  SearchResult = "SearchResult",
  /** Contextual menu shows default content. */
  StandardContextMenu = "StandardContextMenu",
  /** Contextual menu shows ML model or hybrid content of ACM - Adaptive Contextual Menu */
  ZeroTermMenu = "ZeroTermMenu",
}
